import type { ComputedRef, InjectionKey } from 'vue';

/** The accessible names of the tab strip's overflow arrows. component-lib has no
 * i18n of its own, so AppShell provides the host's translation once and every
 * Tabs below it picks it up — a page does not thread two labels through each
 * tab bar it renders. */
export interface TabsLabels {
  previous: string;
  next: string;
}

export const TABS_LABELS_KEY: InjectionKey<ComputedRef<TabsLabels>> = Symbol('lumi-tabs-labels');
